import React, { useState, useEffect } from 'react';
import './EquipmentModal.css';

const machineCategories = {
  'Équipements de levage': [
    'Pont élévateur 2 colonnes',
    'Pont élévateur 4 colonnes',
    'Pont élévateur ciseaux',
    'Cric hydraulique',
    'Chandelle',
    'Grue d\'atelier'
  ],
  'Équipements pneumatiques': [
    'Compresseur d\'air',
    'Pistolet à peinture',
    'Clé à choc pneumatique',
    'Gonfleur de pneus',
    'Soufflette'
  ],
  'Équipements pour pneumatiques': [
    'Démonte-pneu',
    'Équilibreur de roue',
    'Purgeur de freins'
  ],
  'Équipements de diagnostic': [
    'Banc de géométrie',
    'Banc de freinage',
    'Analyseur de gaz',
    'Valise diagnostic',
    'Testeur de batterie'
  ],
  'Équipements de carrosserie': [
    'Marbre de carrosserie',
    'Cabine de peinture',
    'Soudeuse par points',
    'Débosseleur',
    'Tire-clous',
    'Aspirateur industriel'
  ],
  'Équipements de nettoyage': [
    'Nettoyeur haute pression',
    'Machine à laver les pièces',
    'Fontaine de dégraissage'
  ],
  'Autres équipements': [
    'Presse hydraulique',
    'Chargeur de batterie',
    'Extracteur de fumée',
    'Récupérateur d\'huile',
    'Appareil de climatisation'
  ]
};

const ISOLEMENT_OPTIONS = ["1", "10", "M", "B", "<0,5", ">0,5", "100"];

export default function MachineGarageModal({ isOpen, onClose, onSave, local, equipment }) {
  const [formData, setFormData] = useState({
    category: 'machine_garage',
    name: '',
    existing_quantity: 1,
    verified_quantity: 1,
    protection_type: '',
    ce_marking: 'Oui',
    continuity_result: 'Bon',
    isolement: '',
    result: 'conforme'
  });

  const [showOtherName, setShowOtherName] = useState(false);
  const [otherName, setOtherName] = useState('');

  useEffect(() => {
    if (equipment) {
      setFormData(equipment);
      // Vérifier si le nom est dans les options prédéfinies
      const allOptions = Object.values(machineCategories).flat();
      setShowOtherName(equipment.name && !allOptions.includes(equipment.name));
      if (equipment.name && !allOptions.includes(equipment.name)) {
        setOtherName(equipment.name);
      }
    }
  }, [equipment]);

  const handleNameChange = (value) => {
    if (value === 'Autre') {
      setShowOtherName(true);
      setFormData({...formData, name: ''});
    } else {
      setShowOtherName(false);
      setFormData({...formData, name: value});
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const finalName = showOtherName ? otherName : formData.name;
    if (!finalName || !formData.continuity_result) {
      alert('Veuillez remplir tous les champs obligatoires');
      return;
    }
    const finalEquipment = {
      ...formData,
      name: finalName,
      type: 'machine_garage',
    };
    onSave(finalEquipment);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="equipment-modal-overlay" onClick={onClose}>
      <div className="equipment-modal" onClick={(e) => e.stopPropagation()}>
        <div className="equipment-modal-header">
          <div>
            <h2 className="equipment-modal-title">🚗 Machine de garage</h2>
            <p className="equipment-modal-subtitle">{local?.nom}</p>
          </div>
          <button onClick={onClose} className="equipment-close-button">✕</button>
        </div>

        <form onSubmit={handleSubmit} className="equipment-form">
          <div className="equipment-form-scroll">
            <div className="equipment-form-group">
              <label className="equipment-form-label">
                Type de machine de garage <span className="equipment-required">*</span>
              </label>
              <select
                value={showOtherName ? 'Autre' : formData.name || ''}
                onChange={(e) => handleNameChange(e.target.value)}
                className="equipment-form-select"
                required
              >
                <option value="">- Sélectionner -</option>
                {Object.entries(machineCategories).map(([category, items]) => (
                  <optgroup key={category} label={category}>
                    {items.map(item => (
                      <option key={item} value={item}>{item}</option>
                    ))}
                  </optgroup>
                ))}
                <option value="Autre">Autre (texte libre)</option>
              </select>
            </div>

            {showOtherName && (
              <div className="equipment-form-group">
                <label className="equipment-form-label">
                  Précisez le type de machine <span className="equipment-required">*</span>
                </label>
                <input
                  type="text"
                  value={otherName}
                  onChange={(e) => setOtherName(e.target.value)}
                  className="equipment-form-input"
                  placeholder="Entrez le nom de la machine"
                  required
                />
              </div>
            )}

            <div className="equipment-form-row">
              <div className="equipment-form-group">
                <label className="equipment-form-label">Quantité existante</label>
                <input
                  type="number"
                  min="0"
                  value={formData.existing_quantity}
                  onChange={(e) => setFormData({...formData, existing_quantity: parseInt(e.target.value)})}
                  className="equipment-form-input"
                />
              </div>
              <div className="equipment-form-group">
                <label className="equipment-form-label">Quantité vérifiée</label>
                <input
                  type="number"
                  min="0"
                  value={formData.verified_quantity}
                  onChange={(e) => setFormData({...formData, verified_quantity: parseInt(e.target.value)})}
                  className="equipment-form-input"
                />
              </div>
            </div>

            <div className="equipment-form-group">
              <label className="equipment-form-label">Type de protection</label>
              <input
                type="text"
                value={formData.protection_type}
                onChange={(e) => setFormData({...formData, protection_type: e.target.value})}
                className="equipment-form-input"
              />
            </div>

            <div className="equipment-form-group">
              <label className="equipment-form-label">Marquage CE</label>
              <select
                value={formData.ce_marking}
                onChange={(e) => setFormData({...formData, ce_marking: e.target.value})}
                className="equipment-form-select"
              >
                <option value="Oui">Oui</option>
                <option value="Non">Non</option>
              </select>
            </div>

            <div className="equipment-form-group">
              <label className="equipment-form-label">
                Continuité PE <span className="equipment-required">*</span>
              </label>
              <select
                value={formData.continuity_result}
                onChange={(e) => setFormData(prev => ({
                  ...prev,
                  continuity_result: e.target.value,
                  isolement: e.target.value === 'Mauvais' ? '>0,5' : prev.isolement
                }))}
                className="equipment-form-select"
                required
              >
                <option value="">- Sélectionner -</option>
                <option value="Bon">Bon</option>
                <option value="Mauvais">Mauvais</option>
                <option value="Classe II">Classe II</option>
                <option value="Déconnecté">Déconnecté</option>
                <option value="NVE">NVE</option>
                <option value="NVI">NVI</option>
                <option value="NVX">NVX</option>
                <option value="SO-PI">SO-PI</option>
              </select>
            </div>

            <div className="equipment-form-group">
              <label className="equipment-form-label">Isolement (MΩ)</label>
              <input
                type="text"
                list="isolement-options-machine-garage"
                value={formData.isolement || ''}
                onChange={(e) => setFormData({...formData, isolement: e.target.value})}
                className="equipment-form-input"
                placeholder="Ex: >0,5, 1, 10, 100, M, B..."
              />
              <datalist id="isolement-options-machine-garage">
                {ISOLEMENT_OPTIONS.map(opt => <option key={opt} value={opt} />)}
              </datalist>
            </div>
          </div>

          <div className="equipment-form-buttons">
            <button type="button" onClick={onClose} className="equipment-cancel-button">
              ← Retour
            </button>
            <button type="submit" className="equipment-save-button">
              {equipment ? 'Mettre à jour' : '+ Ajouter rapidement'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}